


















































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { PracticeFileUpload, PracticeFile } from "../../modules/teacher/PracticeFileUploadDetail"

export interface Data {
  practice_file_upload_id: string
  practiceFileUpload: PracticeFileUpload
  practiceFiles: PracticeFile[]
  fields: any[]
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalFileUploadRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      practice_file_upload_id: null,
      practiceFileUpload: null,
      practiceFiles: new Array<PracticeFile>(),
      fields: [
        {key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "id", label: "アップロード状態", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "160px"}},
        {key: "download", label: "ダウンロード", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "160px"}},
        {key: "delete", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "160px"}},
      ],
      errors: [],
    });

    const allDownloadSelectChanged = (isChecked: boolean) => {
      state.practiceFiles.filter(x => x.id).forEach(x => x.is_download_checked = isChecked);
    }

    const allDeleteSelectChanged = (isChecked: boolean) => {
      state.practiceFiles.filter(x => x.id).forEach(x => x.is_delete_checked = isChecked);
    }

    const destroy = async () => {

      state.errors = [];

      const ids = state.practiceFiles.filter(x => x.is_delete_checked).map(x => x.id);

      if(ids.length == 0){
        alert("削除対象を選択してください。");
        return;
      }

      if (!window.confirm('選択している生徒のファイルを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_file_upload_detail_person/destroy`, {practice_file_upload_id: state.practice_file_upload_id, ids: ids}).then(response => {
        alert("処理が完了しました。");
        if(response.data.practice_files_count > 0){
          window.location.reload();
        }else{
          // PDFが0件になった場合は一覧に戻る
          window.history.back();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    const download = async () => {

      state.errors = [];

      const student_no_characters = state.practiceFiles.filter(x => x.is_download_checked).map(x => x.student_no_character);

      if(student_no_characters.length == 0){
        alert("ダウンロード対象を選択してください。");
        return;
      }

      if (!window.confirm('選択している生徒のファイルをダウンロードします。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_file_upload_detail_person/download`, {practice_file_upload_id: state.practice_file_upload_id, student_no_characters: student_no_characters}, {responseType: 'blob'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.practiceFileUpload.title}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * アップロード
     ************************************************************/

    const upload = async (file: any) => {
      state.errors = [];

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append('practice_file_upload_id', state.practice_file_upload_id);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_file_upload_detail_person/upload`, fd).then(async response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.practice_file_upload_id = context.root.$route.params.practice_file_upload_id;
      await http.get(`/api/teacher/practice_file_upload_detail_person?practice_file_upload_id=${state.practice_file_upload_id}`).then(response => {
        state.practiceFileUpload = new PracticeFileUpload(response.data.practice_file_upload);
        state.practiceFiles = response.data.practice_files.map((x: any) => new PracticeFile(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`データの取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`データの取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalFileUploadRef,
      allDownloadSelectChanged,
      allDeleteSelectChanged,
      destroy,
      download,
      upload,
    };
  }
});

